/* import __COLOCATED_TEMPLATE__ from './header-new-workflows-btn.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { getWorkflowLimit } from 'embercom/lib/workflows/constants/limits';
import type AppService from 'embercom/services/app-service';

const WORKFLOW_WARNING_THRESHOLD = 950;

interface Args {
  openCreateFromScratchModal: () => void;
  openCreateFromTemplateModal: () => void;
  totalWorkflowsCount?: number;
}

export default class HeaderNewWorkflowsBtn extends Component<Args> {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get workflowLimit() {
    return getWorkflowLimit(this.appService.app?.id);
  }

  get isDisabled() {
    return (this.args.totalWorkflowsCount ?? 0) >= this.workflowLimit;
  }

  get isApproachingLimit() {
    let count = this.args.totalWorkflowsCount ?? 0;
    return count >= WORKFLOW_WARNING_THRESHOLD && count < this.workflowLimit;
  }

  get shouldShowTooltip() {
    return this.isApproachingLimit || this.isDisabled;
  }

  get tooltipMessage() {
    if (this.isDisabled) {
      return this.intl.t('operator.custom-bot.header.workflow-limit-reached', {
        limit: this.workflowLimit,
      });
    }
    return this.intl.t('operator.custom-bot.header.workflow-limit-approaching', {
      limit: this.workflowLimit,
    });
  }

  get dropdownItems() {
    return [
      {
        items: [
          {
            icon: 'add',
            text: this.intl.t(
              'outbound.new-content-modal.workflows.template-selector.create-new-workflow-from-template',
            ),
            onSelectItem: this.args.openCreateFromTemplateModal,
            disabled: this.isDisabled,
          },
          {
            icon: 'post-filled',
            text: this.intl.t(
              'outbound.new-content-modal.workflows.template-selector.create-new-workflow',
            ),
            onSelectItem: this.args.openCreateFromScratchModal,
            disabled: this.isDisabled,
          },
        ],
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CustomBots::HeaderNewWorkflowsBtn': typeof HeaderNewWorkflowsBtn;
  }
}
